import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
import { attributesDetailSchema } from "./attributes.js";
import { guideIconHtml } from "@scalar-org/guide-icons";
import { validate } from "../../helpers/validate.js";
const scalarDetail = {
  name: "scalar-detail",
  tagName: "scalar-detail",
  tiptapName: "details",
  attributeTransform: (_, attrs) => {
    const icon = "icon" in attrs ? String(attrs.icon) : void 0;
    const open = "open" in attrs ? Boolean(attrs.open) : void 0;
    const transformed = {
      id: String(attrs.id),
      title: String(attrs.title ?? ""),
      interactivity: "interactivity" in attrs ? String(attrs.interactivity) : void 0,
      icon,
      open
    };
    return validate(attributesDetailSchema, transformed);
  },
  render: async (props) => {
    const interactive = !(props.interactivity?.toLowerCase() === "none");
    const detailsOrDiv = interactive ? "details" : "div";
    const summaryOrDiv = interactive ? "summary" : "div";
    const icon = props.icon ? String(props.icon) : "line/arrow-chevron-right";
    const isOpen = (interactive && props.open) ?? false;
    const classNames = [EditorClasses.Detail].join(" ");
    return html`
    <${detailsOrDiv} class="${classNames}" ${isOpen ? "open" : ""}>
      <${summaryOrDiv} class="${EditorClasses.Detail}-summary">
        ${interactive ? html`<div class="${EditorClasses.Detail}-marker">${await guideIconHtml(
      {
        src: icon
      }
    )}</div>` : ""}
        <span class="${EditorClasses.Detail}-title">${props.title}</span>
      </${summaryOrDiv}>
      <div class="${EditorClasses.Detail}-content">
        <ssg-children></ssg-children>
      </div>
    </${detailsOrDiv}>
    `;
  }
};
export {
  scalarDetail
};
//# sourceMappingURL=index.js.map
